export default {"src":"/_next/static/media/selfEmployed.242d1a62.svg","height":117,"width":138};